import { httpClient } from "./httpClient";

const getHomepageForHunter = () => {
  return httpClient.get("homepage/hunter");
};

export default {
  getHomepageForHunter,
};
